var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMissedPaymentModalIcon = function SvgMissedPaymentModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.828 0H2.172C.972 0 0 .973 0 2.172v8.69c0 1.2.973 2.172 2.172 2.172h58.656c1.2 0 2.172-.972 2.172-2.172v-8.69C63 .972 62.027 0 60.828 0Z",
    fill: "#7F8499"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.482 7.603H6.517a1.086 1.086 0 0 1 0-2.172h49.965a1.086 1.086 0 0 1 0 2.172Z",
    fill: "#464655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.775 5.43v39.104c0 1.8 1.46 3.259 3.259 3.259h36.931c1.8 0 3.259-1.46 3.259-3.259V5.431H9.775Z",
    fill: "#03C8B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.354 19.008c-.6 0-1.086-.486-1.086-1.086v-2.716a1.086 1.086 0 1 1 2.172 0v2.716c0 .6-.486 1.086-1.086 1.086ZM23.354 27.155c-.6 0-1.086-.487-1.086-1.087v-2.715a1.086 1.086 0 1 1 2.172 0v2.715c0 .6-.486 1.087-1.086 1.087Z",
    fill: "#AFB9D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.241 28.241c-.6 0-1.086-.486-1.086-1.086V17.38a1.086 1.086 0 1 1 2.173 0v9.776c0 .6-.486 1.086-1.087 1.086ZM28.241 42.362c-.6 0-1.086-.486-1.086-1.086V31.5a1.086 1.086 0 1 1 2.173 0v9.776c0 .6-.486 1.086-1.087 1.086Z",
    fill: "#C7CFE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.276 41.276a5.43 5.43 0 1 0 0-10.862 5.43 5.43 0 0 0 0 10.862Z",
    fill: "#007E84"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.276 33.673a5.43 5.43 0 1 0 0-10.862 5.43 5.43 0 0 0 0 10.862ZM53.224 5.43H9.775v2.173h43.449V5.431Z",
    fill: "#007E84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.276 30.414a5.41 5.41 0 0 0-3.873 1.63 5.409 5.409 0 0 0 3.873 1.629 5.41 5.41 0 0 0 3.872-1.63 5.408 5.408 0 0 0-3.873-1.629Z",
    fill: "#045C61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.155 5.43v7.604a1.086 1.086 0 1 0 2.172 0V5.431h-2.172ZM17.379 5.43v7.604a1.086 1.086 0 1 0 2.172 0V5.431H17.38Z",
    fill: "#C7CFE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.551 5.43H17.38v2.173h2.172V5.431ZM29.327 5.43h-2.172v2.173h2.172V5.431Z",
    fill: "#AFB9D2"
  })));
};

export default SvgMissedPaymentModalIcon;